import * as React from 'react';

const HappyCoLogoSVG = (props)=>{
    return React.createElement("svg", {
        viewBox: "0 0 28 24",
        fill: "none",
        ...props
    }, React.createElement("path", {
        d: "M13.884 24C8.747 24 4 21.45 1.186 17.178c-.6-.91-.34-2.129.58-2.722a2 2 0 012.75.574 11.183 11.183 0 009.368 5.036c3.788 0 7.29-1.883 9.368-5.036a2 2 0 012.75-.574c.92.593 1.18 1.812.58 2.722C23.768 21.45 19.02 24 13.884 24zm-6.78-10.341c1.897 0 3.64-.667 4.662-1.783.396-.43.573-.856.573-1.38 0-.96-.688-1.63-1.674-1.63-.608 0-.962.195-1.258.406-.426.316-1.14.845-2.275.845-2.098 0-3.037-1.652-3.037-3.288 0-1.637.939-3.288 3.037-3.288 1.139 0 1.851.53 2.28.849.291.207.646.4 1.254.4.985 0 1.673-.669 1.673-1.627 0-.533-.17-.946-.572-1.38C10.743.665 9 0 7.104 0 2.921 0 0 2.808 0 6.829s2.921 6.83 7.104 6.83zm6.863-6.83C13.967 2.935 16.934 0 20.87 0c3.933 0 6.898 2.935 6.898 6.829 0 3.894-2.965 6.83-6.898 6.83-3.935 0-6.902-2.936-6.902-6.83zm6.902 3.232c1.88 0 2.864-1.626 2.864-3.232 0-1.606-.984-3.232-2.864-3.232-1.882 0-2.867 1.626-2.867 3.232 0 1.606.985 3.232 2.867 3.232z",
        fill: "currentColor"
    }));
};

export { HappyCoLogoSVG };
